// Static
import menuList from "@/app/static/json/nav-menu-links.json";

// Mixins
import { userMixins } from "@/app/mixins/modules/user-mixins.js";
import { toastMessageMixins } from "@/app/mixins/utils/toast-message-mixins.js";

// Services
import petOrderService from "@/app/services/main/pet-order/pet-order-service.js";
import orderService from "@/app/services/main/orders/orders-service.js";
import dogPurchaseService from "@/app/services/main/dog-purchase/dog-purchase-service.js";
import breederService from "@/app/services/main/breeder/breeder-service.js";
import puppySellService from "@/app/services/main/puppy-sell/puppy-sell-service.js";

// Constants
import { STATUS_CODES } from "@/app/constants/constants.js";

// Vue modules
import EventBus from "@/app/bus/event-bus.js";

export default {
    name: "Sidebar",
    mixins: [userMixins, toastMessageMixins],
    data() {
        return {
            menuList: menuList,
            displaySideBar: false,
            fadeSideBar: false,
        };
    },
    async created() {
        await this.getDogPurchasePendingRequest();
        await this.getDogPurchaseNotifs();
        await this.getOrderForDeliveryNotifs();
        EventBus.$on("getDogPurchaseCount", this.getDogPurchaseNotifs);
        EventBus.$on("getOrderCount", this.getOrderForDeliveryNotifs);
        await this.getUnverifiedBreeder();
        await this.getPendingPuppySellCount();
        EventBus.$on("getPendingBreedersCount", this.getUnverifiedBreeder);
        EventBus.$on("getPendingPuppySellCount", this.getPendingPuppySellCount);
    },
    computed: {
        showSideBar() {
            this.animateSideBar();
            return this.$store.getters.getSideBar;
        },
        overdueTreatmentCount() {
            return this.$store.getters.getOverdueTreatmentCount;
        },
        dogPurchasePendingRequest() {
            return this.$store.getters.getdogPurchasePendingRequestCount;
        },
        dogPurchaseRequests() {
            return this.$store.getters.getDogPurchaseNotification;
        },
        orderCount() {
            return this.$store.getters.getOrderNotification;
        },
        unverifiedBreederCount() {
            return this.$store.getters.getUnverifiedBreederCount;
        },
        pendingPuppySellCount() {
            return this.$store.getters.getPendingPuppySellCount;
        },
        petPurchases() {  
            const puppyPendingCount = this.$store.getters.getPendingPuppySellCount;

            if(puppyPendingCount){
                return puppyPendingCount;
            }

            return 0;
        }
    },
    methods: {
        animateSideBar() {
            const sidebar = this.$store.getters.getSideBar;
            let timeout = sidebar ? 50 : 250;

            if (sidebar) {
                this.displaySideBar = sidebar;
                setTimeout(() => {
                    this.fadeSideBar = sidebar;
                }, timeout);
            } else {
                this.fadeSideBar = sidebar;
                setTimeout(() => {
                    this.displaySideBar = sidebar;
                }, timeout);
            }
        },
        toggleSideBar() {
            this.$store.commit("toggleSideBar");
            this.animateSideBar();
        },
        closeSideBarOnNavigate() {
            let filters = this.$store.state.subscriptionFilters.filters;
            const hasSubsFilters = filters && Object.keys(filters).length > 0; 
            if (hasSubsFilters) {
                this.$store.dispatch('resetFilters');
            }

            filters = this.$store.state.treatmentFilters.filters;
            const hasTreatmentFilters = filters && Object.keys(filters).length > 0; 
            if (hasTreatmentFilters) {
                this.$store.dispatch('resetTreatmentFilters');
            }
            this.$store.commit("closeSideBar");
            this.animateSideBar();
        },
        getDogPurchasePendingRequest() {
            this.isAPILoading = true;

            dogPurchaseService
                .getDogPurchasePendingRequestCount()
                .then((res) => {
                    if (res.status === STATUS_CODES.SUCCESS) {
                        this.$store.commit("setdogPurchasePendingRequestCount", res.data.pendingRequest);
                    } else {
                        this.showAPIErrorToast("Unable to fetch dog purchase count.", res);
                    }
                })
                .catch(() => {
                    this.showGenericErrorToast();
                })
                .finally(() => {
                    this.isAPILoading = false;
                });
        },
        getDogPurchaseNotifs() {
            this.isAPILoading = true;

            petOrderService
                .getPetOrderCount()
                .then((res) => {
                    if (res.status === STATUS_CODES.SUCCESS) {
                        this.$store.commit("setDogPurchaseNotification", res.data.pendingRequest);
                    } else {
                        this.showAPIErrorToast("Unable to fetch dog purchase count.", res);
                    }
                })
                .catch(() => {
                    this.showGenericErrorToast();
                })
                .finally(() => {
                    this.isAPILoading = false;
                });
        },
        getOrderForDeliveryNotifs() {
            this.isAPILoading = true;

            orderService
                .getOrderForDeliveryCount()
                .then((res) => {
                    if (res.status === STATUS_CODES.SUCCESS) {
                        this.$store.commit("setOrderNotification", res.data.forDelivery);
                    }
                })
                .catch(() => {
                    this.showGenericErrorToast();
                })
                .finally(() => {
                    this.isAPILoading = false;
                });
        },
        getUnverifiedBreeder() {
            this.isAPILoading = true;

            breederService
                .getUnverifiedBreeder()
                .then((res) => {
                    if (res.status === STATUS_CODES.SUCCESS) {
                        this.$store.commit("setUnverifiedBreederCount", res.data.count);
                    } else {
                        this.showAPIErrorToast("Unable to fetch unverfied breeder count.", res);
                    }
                })
                .catch(() => {
                    this.showGenericErrorToast();
                })
                .finally(() => {
                    this.isAPILoading = false;
                });
        },
        getPendingPuppySellCount() {
            this.isAPILoading = true;

            puppySellService
                .getPendingPuppySellCount()
                .then((res) => {
                    if (res.status === STATUS_CODES.SUCCESS) {
                        this.$store.commit("setPendingPuppySellCount", res.data.count);
                    } else {
                        this.showAPIErrorToast("Unable to fetch unverfied breeder count.", res);
                    }
                })
                .catch(() => {
                    this.showGenericErrorToast();
                })
                .finally(() => {
                    this.isAPILoading = false;
                });
        },
    },
    beforeDestroy() {
        EventBus.$off("getDogPurchaseCount", this.getDogPurchaseNotifs);
        EventBus.$off("getOrderCount", this.getOrderForDeliveryNotifs);
    },
};
